import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { retry, shareReplay } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { YoutubeApi } from 'src/models/youtubeapi';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class LiveStreamService {

    constructor(private http: HttpClient) { }
    private liveStreamApiUrl = "https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCAaOe29GRIl6pv03FDmfbXA&type=video&eventType=live&key=AIzaSyATFBB4DRfoALvR4PpdR9TzEovBpQc40CM";

    getYoutubeIsLiveResponse(): Observable<YoutubeApi> {
        return this.http.get<YoutubeApi>(this.liveStreamApiUrl)
            .pipe(
                retry({ count: 2, delay: 500}), shareReplay());
    }
}
